import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';
import UserAgentUtils from '../../../../utils/userAgent';
import { Format, StyleColor, BaseStyledComponentProps, notchHeight, macTopBarHeight } from '../../../../utils/styles-constants';
import { hexToRgba } from '../../../../utils/style';

interface ButtonActionProps extends BaseStyledComponentProps {
	disabled?: boolean;
}

const SearchFieldContainer = styled('div')`
	box-sizing: border-box;
	position: absolute;
	width: 100%;
	top: 0;
	left: 0;
	z-index: 10;
	transition: all 0.3s;
	background-color: ${({ theme: { primary: { backgroundColor } } }: BaseStyledComponentProps) => backgroundColor !== 'transparent' ? backgroundColor : StyleColor.White };
	box-shadow: 0 5px 10px 1px ${hexToRgba(StyleColor.Black, 10)};

	${UserAgentUtils.isMacApp() && `
		padding-top: ${macTopBarHeight};
		top: -${macTopBarHeight};
	`}

	${UserAgentUtils.isIOS() && `
		@media ${Format.SmartphonePortraitNotch} {
			padding-top: ${notchHeight};
			top: -${notchHeight};
		}
	`}
`;

const SearchFieldHeader = styled('div')`
	display: flex;
	align-items: center;
	height: 50px;
	padding: 0 20px;

	@media ${Format.Smartphone} {
		padding: 0 10px;
	}
`;

const SearchFieldHeaderSection = styled('div')`
	flex: 1 1 33.33%;
	display: flex;

	&:nth-child(2) {
		justify-content: center;
	}

	&:last-child {
		justify-content: flex-end;
	}
`;

const SearchFieldBody = styled('div')`
	display: flex;
	flex-direction: column;
	padding: 15px 50px;

	@media ${Format.Smartphone} {
		padding: 10px 25px;
	}
`;

const ButtonAction = styled('button').attrs({
	type: 'button',
})`
	padding: 0;
	border: 0;
	outline: 0;
	background-color: transparent;
	font-family: HelveticaNeue, sans-serif;
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	color: ${(props: ButtonActionProps) => props.theme.primary.actionColor};
	letter-spacing: 0.5px;
	cursor: pointer;

	${(props: ButtonActionProps) => props.disabled && `
		cursor: default;
		opacity: 0.5;
	`}
`;

const SearchFieldHeaderLabel = styled(Translate)`
	font-family: HelveticaNeue, sans-serif;
	font-weight: 500;
	font-size: 18px;
	line-height: 20px;
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.strongColor};
	text-align: center;
`;

const SearchFieldBar = styled('div')`
	display: flex;
	align-items: center;
	transition: all 0.2s;
	overflow: hidden;
	background: ${StyleColor.Grey50};
	border: 1px solid ${StyleColor.Grey100};
	border-radius: 10px;
	height: 36px;
	width: 100%;
`;

const SearchFieldInput = styled('input')`
	background: ${StyleColor.Grey50};
	flex-grow: 1;
	outline: 0;
	text-overflow: ellipsis;
	color: ${hexToRgba(StyleColor.Black, 50)};
	font-size: 15px;
	letter-spacing: 0.15px;
	border: 0;

	::placeholder{
		color: ${hexToRgba(StyleColor.Black, 50)};
	};

	/* removes the clear field "X" button automatically added by IE & Edge*/
	::-ms-clear {
		display: none;
	}
`;

const SearchFieldIcon = styled('div')`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	margin: 0 10px;
	padding: 1px 6px;

	svg {
		fill: ${hexToRgba(StyleColor.Black, 50)};
		width: 16px;
		height: 16px;
	}
`;

const ButtonClear = styled('button')`
	width: 30px;
	height: 30px;
	margin: 0 10px;
	padding: 1px 6px;
	border: 0;
	background: none;
	outline: 0;
	cursor: pointer;

	svg {
		fill: ${StyleColor.Grey500};
		width: 100%;
		height: 100%;
	}
`;

export {
	SearchFieldContainer,
	SearchFieldHeader,
	SearchFieldHeaderSection,
	SearchFieldHeaderLabel,
	SearchFieldBody,
	SearchFieldInput,
	SearchFieldBar,
	SearchFieldIcon,
	ButtonClear,
	ButtonAction,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/Search/Field/styles.ts